import { render } from "./PositionStructure.vue?vue&type=template&id=4ef89c80&scoped=true"
import script from "./PositionStructure.vue?vue&type=script&lang=js"
export * from "./PositionStructure.vue?vue&type=script&lang=js"

import "./PositionStructure.vue?vue&type=style&index=0&id=4ef89c80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef89c80"]])

export default __exports__